import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const PaymentPage = () => {
  const stripePromise = loadStripe(
    "pk_live_51NN8lpFAs62BkuhunQtmDQXNEEJvCGWMfsRfxPpWLGGl0EMaR4mwTPG3yMx4ksiKKhe2VTkVa3vVpKQoowZ8gpVz00nGtynxUN"
  );
  const keys = [
    "name",
    "email",
    "mobileNumber",
    "school",
    "schoolCode",
    "grade",
  ];
  const values = keys.map((key) => sessionStorage.getItem(key));
  const navigate = useNavigate();

  const fetchClientSecret = useCallback(async () => {
    try {
      // Check if all values are defined
      // Define field names for reference
      const fieldNames = [
        "name",
        "email",
        "phone",
        "school",
        "schoolCode",
        "grade",
      ];
      const missingFields = fieldNames.filter((_, index) => !values[index]);

      // Check if there are any missing or empty fields
      if (missingFields.length > 0) {
        throw new Error(
          `Please fill in the following required fields: ${missingFields.join(
            ", "
          )}`
        );
      }

      // Create a Checkout Session
      const response = await fetch(
        "https://payments-api.nationalfinanceolympiad.com/nfo/stripe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            amount: 990, // example amount in cents ($10)
            name: values[0],
            email: values[1],
            phone: values[2],
            school: values[3],
            schoolCode: values[4],
            grade: values[5],
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const { data } = await response.json();
      console.log(data.id);
      return data.clientSecret; // Assuming `data.id` is the client secret you need
    } catch (error) {
      console.error("Error fetching client secret:", error);
      alert(error);
      navigate(-1);
      return null;
    }
  }, [values]);

  const verifyPaymentComplete = useCallback(async () => {
    try {
      // Create a Checkout Session
      const response = await fetch(
        "https://payments-api.nationalfinanceolympiad.com/nfo/stripe-metadata",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sessionId: "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const { data } = await response.json();
      console.log(data.id);
      return data.clientSecret; // Assuming `data.id` is the client secret you need
    } catch (error) {
      console.error("Error fetching client secret:", error);
      // Handle the error accordingly
      return null; // Or throw error depending on your error handling strategy
    }
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        justifyContent: "center",
        backgroundColor: "#FFF",
        paddingTop: "2%",
        paddingBottom: "2%",
      }}
    >
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={{
          fetchClientSecret: fetchClientSecret,
          //@ts-ignore
          onComplete: (event: any) => {
            console.log("this si the event", event);
          },
        }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default PaymentPage;
